(function() {
  'use strict';

  angular
    .module('admin.hashtags.service', [])
    .factory('HashtagsService', HashtagsService);

  /** @ngInject */
  function HashtagsService($http, $q, API) {
    function list(){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/hashtags/trending')
          .success(defered.resolve);

        return defered.promise;
    }

    function listDisplayed(start, limit, sort){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/hashtags?start=' + start + '&limit=' + limit + '&sort=' + sort)
        .success(defered.resolve);

      return defered.promise;
    }

    function listSearchDisplayed(start, limit, sort, name){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/hashtags/search?h=' + name + '&start=' + start + '&limit=' + limit + '&sort=' + sort)
        .success(defered.resolve);

      return defered.promise;
    }

    function addBlacklist(id){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/hashtags/blacklist')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function create(hashtag){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/hashtags?new_tag=' + hashtag)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(model){
      var defered = $q.defer();

      $http.put(API.API_URL + 'admin/hashtags/cache', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTop(model){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/hashtags/top', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function reset(){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/hashtags/reset', {})
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function remove(id){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/hashtags/' + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      list: list,
      listDisplayed: listDisplayed,
      listSearchDisplayed: listSearchDisplayed,
      addBlacklist: addBlacklist,
      create: create,
      update: update,
      updateTop: updateTop,
      reset: reset,
      remove: remove,
    };
  }

})();
